"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROFILES_ROUTES = void 0;
const profile_collections_page_1 = __importDefault(require("@pages/profile-collections-page"));
const profile_portfolio_page_1 = __importDefault(require("@pages/profile-portfolio-page"));
const become_creator_page_1 = __importDefault(require("@pages/become-creator-page"));
const profile_stats_page_1 = __importDefault(require("@pages/profile-stats-page"));
const ref_page_1 = __importDefault(require("@pages/ref-page"));
exports.PROFILES_ROUTES = [
    {
        path: "profile",
        component: profile_portfolio_page_1.default,
        exact: true,
    },
    {
        path: "profile/collections",
        component: profile_collections_page_1.default,
        exact: true,
    },
    {
        path: "profile/stats",
        component: profile_stats_page_1.default,
        exact: true,
    },
    {
        path: "profile/ref",
        component: ref_page_1.default,
        exact: true,
    },
    {
        path: "profile/become-creator",
        component: become_creator_page_1.default,
        exact: true,
    },
    {
        path: "profile/:id(0x[a-fA-F0-9]{40})",
        component: profile_portfolio_page_1.default,
        exact: true,
    },
    {
        path: "profile/:id(0x[a-fA-F0-9]{40})/collections",
        component: profile_collections_page_1.default,
        exact: true,
    },
    {
        path: "profile/:id(0x[a-fA-F0-9]{40})/stats",
        component: profile_stats_page_1.default,
        exact: true,
    },
];
